import { render, staticRenderFns } from "./FormProductPackaging.vue?vue&type=template&id=33c4e66a&scoped=true&"
import script from "./FormProductPackaging.vue?vue&type=script&lang=true&"
export * from "./FormProductPackaging.vue?vue&type=script&lang=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c4e66a",
  null
  
)

export default component.exports